
export interface Notification {
  id: string;
  title: string;
  message: string;
  timestamp: string;
  read: boolean;
  type: 'rental' | 'payment' | 'system' | 'warning' | 'subscription' | 'error';
}

// Вспомогательная функция для получения текстового описания статуса платежа
export const getPaymentStatusText = (status: string): string => {
  switch (status) {
    case 'paid':
      return 'успешно оплачен';
    case 'pending':
      return 'ожидает оплаты';
    case 'error':
      // ИСПРАВЛЕНО: Меняем текст с "ошибка платежа" на "отменен"
      return 'отменен';
    case 'completed':
      return 'завершен';
    default:
      return status;
  }
};

// Вспомогательная функция для склонения слова "день"
export const getDaysWord = (days: number): string => {
  if (days === 1) return 'день';
  if (days >= 2 && days <= 4) return 'дня';
  return 'дней';
};

// Вспомогательная функция для создания уникального ID уведомления
export const createNotificationId = (prefix: string): string => {
  return `${prefix}-${Date.now()}-${Math.random().toString(36).substring(2, 9)}`;
};

// Исправляем тип для функции добавления уведомлений
export interface NotificationData {
  title: string;
  message: string;
  type: 'system' | 'warning' | 'payment' | 'rental' | 'subscription' | 'error';
  id?: string;
}

export interface NotificationManager {
  totalCount: number;
  notifications: Notification[];
  unreadCount: number;
  showAllNotifications: () => void;
  markAsRead: (id: string) => void;
  addNotification: (data: NotificationData) => void;
}
